import { Article, SwatchbookBase } from '@doist/icons/brand'
import { Box, type BoxProps, Button, Heading, type HeadingProps } from '@doist/marketist'

export type MoreResourcesProps = {
    title: string
    titleLevel?: HeadingProps['level']
    items: { title: string; url: string }[]
} & BoxProps

export function MoreResources({ title, titleLevel = '2', items, ...rest }: MoreResourcesProps) {
    return (
        <Box {...rest}>
            <Heading level={titleLevel} size="minor-base" weight="semibold" className="mbe-8">
                {title}
            </Heading>
            <ul>
                {items.map((item) => (
                    <li key={item.title}>
                        <Button
                            href={item.url}
                            variant="tertiary"
                            startIcon={isTemplateUrl(item.url) ? SwatchbookBase : Article}
                            bleed="inline"
                            iconAlign="top"
                        >
                            {item.title}
                        </Button>
                    </li>
                ))}
            </ul>
        </Box>
    )
}

function isTemplateUrl(url: string) {
    return url.startsWith('https://www.todoist.com') && url.includes('/templates/')
}
